import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { isEmpty } from "lodash";

import InputView from "components/OptionsBox/InputView/index";
import { addNewMessage, filterEditMessages, removeAndAddMessages, updateFaq } from "slices/messages-slice/index";
import { setIsDisabled } from "slices/option-box-slice/index";
import { selectOptionsTypeLogs, setOptionsTypeLogs, setReplies } from "slices/replies-slice/index";
import { defaultEditFormats, ERROR_MSG, optionTypes } from "utils/constants/index";
import { formatMessageEdit, getNextOptions, makeNextOptions } from "utils/methods/index";
import { getQualificationButtonEnabled } from "slices/property-slice/index";
import { Icon } from "components";
import { getArtieLogo, getIsMaximized, removeLoadingMsgs } from "slices";
import { renderMascot } from "utils";
import ExtraOption from "components/OptionsBox/ExtraOptions/index";
export const DoIQualify = ({ available_tourTypes = [], isLastBot, staticImageData, isUserMsg, position, mascotSettings, customSize, message, subject }) => {
  const dispatch = useDispatch();
  const optionsTypeLogs = useSelector(selectOptionsTypeLogs);
  const artieLogo = useSelector(getArtieLogo);
  const isMaximized = useSelector(getIsMaximized);
  const qualification_button_enabled = useSelector(getQualificationButtonEnabled);

  const onClick = (messages, nextOptionsType, disablePlaceholerMessage, callbackOptions, data = null, isAMA, context, customBtnText, customBtnId) => {
    let duplicate_messages = [];

    messages?.forEach((msg) => {
      let message = {
        ...msg,
        createdAt: msg.message === "Ask Me Anything" && msg.optionsType === "Init" && msg.key === "faqs" ? new Date() : new Date(),
      };
      duplicate_messages.push(message);
    });

    if (nextOptionsType == "Init") {
      formatMessageEdit("Init");

      return;
    }

    if (defaultEditFormats.includes(nextOptionsType)) {
      dispatch(filterEditMessages([]));
    }

    dispatch(addNewMessage(duplicate_messages));

    if (nextOptionsType) {
      if (!disablePlaceholerMessage) {
        if (duplicate_messages.length === 1 && duplicate_messages[0].message === "Ask Me Anything" && duplicate_messages[0].key === "faqs") {
          //todo: update after release
        } else {
          setTimeout(() => {
            const message = optionTypes[nextOptionsType] || `typing`;
            dispatch(addNewMessage([{ message: message, speaker: "bot", createdAt: new Date().toISOString() }]));
          }, 300);
        }
      }

      dispatch(setIsDisabled(true));

      const handleNextOptionsSuccess = (res) => {
        const { nextReplies, nextBotMessages } = makeNextOptions(nextOptionsType, res.data, res.extraData || undefined, isAMA, res.skip);

        if (nextReplies.options.length > 1 || nextOptionsType === "DoIQualify") {
          dispatch(updateFaq(false));
        } else {
          if (nextOptionsType === "Cancel") {
            dispatch(updateFaq(true));
          }
        }

        let duplicateMessages = nextBotMessages || [];
        let newMessages = [];

        duplicateMessages?.forEach((msg) => {
          let message = { ...msg, createdAt: new Date() };
          newMessages.push(message);
        });

        if (!disablePlaceholerMessage) {
          if (duplicate_messages.length === 1 && duplicate_messages[0].message === "Ask Me Anything" && duplicate_messages[0].key === "faqs") {
            //todo: update after release
          } else {
            setTimeout(() => {
              dispatch(removeAndAddMessages(newMessages));
            }, 300);
          }
        } else {
          dispatch(addNewMessage(newMessages));
        }

        dispatch(setReplies(nextReplies));
        dispatch(setIsDisabled(false));

        if (nextOptionsType !== replies.optionsType) {
          dispatch(setOptionsTypeLogs([...optionsTypeLogs, replies.optionsType]));
        }
      };

      getNextOptions(nextOptionsType, data, isAMA, context, available_tourTypes, customBtnId)
        .then((res) => {
          handleNextOptionsSuccess(res);
        })
        .catch(async (err) => {
          dispatch(addNewMessage([{ message: ERROR_MSG, speaker: "bot", subject: "", createdAt: new Date() }]));

          setTimeout(() => {
            dispatch(removeLoadingMsgs());
          }, 100);
        })
        .finally(() => {
          dispatch(setIsDisabled(false));
        });
    }
  };

  const replies = {
    options: [
      {
        content: {
          component: "FullWidthInput",
          componentOptions: {
            callbackOptions: null,
            label: "doIQualify",
            officialLabel: "doIQualify",
            placeholder: "Enter the amount here...",
            type: "number",
            validate: null,
          },
        },
        data: null,
        disablePlaceholerMessage: false,
        event: "h_click",
        key: "do_i_qualify",
        message: [],
        nextOptionsType: "Init",
      },
    ],

    optionsType: "DoIQualify",
    renderType: "inputView",
    title: "",
  };

  return (
    <div>
      <div className={`hayley-flex ${isLastBot && (isMaximized ? "hayley-mb-4" : "hayley-mb-3")}`}>
        {isUserMsg ? (
          isMaximized ? (
            <Icon iconType="DefaultUser" classes={"hayley-h-9 hayley-w-9 hayley-object-cover"} />
          ) : (
            ""
          )
        ) : (
          <>
            {isEmpty(artieLogo) && <div className="hayley-h-9 hayley-w-9">{renderMascot(mascotSettings, position, true, customSize, false)}</div>}

            {!isEmpty(artieLogo) && (
              <div className="hayley-z-10 hayley-flex hayley-h-9 hayley-w-9 hayley-items-center hayley-justify-center hayley-rounded-full hayley-border hayley-border-[#EEE]">
                <img
                  id="staticImage"
                  src={artieLogo.includes("data:image/gif") ? staticImageData : artieLogo}
                  alt=""
                  className={`hayley-h-8 hayley-w-8 hayley-rounded-full hayley-object-cover`}
                />
              </div>
            )}
          </>
        )}
        <div className="hayley-mx-3 hayley-flex hayley-max-w-[725px] hayley-flex-col">
          <div className="hayley-mb-4 hayley-w-fit hayley-rounded-lg hayley-rounded-tl-none hayley-bg-custom-7 !hayley-px-4 !hayley-py-2 hayley-text-sm hayley-text-secondary">
            {message}
          </div>
          {qualification_button_enabled && isLastBot && <InputView replies={replies} onClick={onClick} />}

          {!qualification_button_enabled && isLastBot ? <ExtraOption extraButtons={null} /> : null}
        </div>
      </div>
    </div>
  );
};
